import * as types from './types';
import i18n from '../../../i18n';

export default {
  // to enable or disable loading screen
  startLoading(context) {
    context.commit(types.LOADING_START);
  },
  finishLoading(context) {
    context.commit(types.LOADING_FINISH);
  },
  // to display and error text is the error message and time the time to display in sec
  displaySnackbar(context, params) {
    // translate the error message if needed
    if (params.text === 'Erreur lors de la création du signataire ! <br> Account already exists and is not linkable to your signers list') {
      const messageArray = params.text.split(' ');
      const lineBreakIndex = messageArray.indexOf('<br>');
      // text after lineBreakIndex is not translated
      if (lineBreakIndex > -1 && messageArray.slice(lineBreakIndex + 1).join(' ') === 'Account already exists and is not linkable to your signers list') {
        messageArray.splice(lineBreakIndex + 1, messageArray.length - (lineBreakIndex + 1), i18n.t('signatory.form.email.error.emailAlreadyUsed'));
        params.text = messageArray.join(' ');
      }
    }

    // open snack bar
    context.commit(types.DISPLAY_ERROR_OPEN, params);
    // after param time close snack bar
    setTimeout(() => {
      context.commit(types.DISPLAY_ERROR_CLOSE);
      // after leaving animation reset snackbar position
      setTimeout(() => {
        context.commit(types.RESET_SNACKBAR);
      }, 500);
    }, (params.time * 1000));
  },
  setIsMobile({ commit }) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      commit(types.SET_IS_MOBILE, true);
    } else {
      commit(types.SET_IS_MOBILE, false);
    }
  },
  updateResponsive({ commit }) {
    commit(types.UPDATE_RESPONSIVE, document.documentElement.clientWidth);
  },
  setLastBreadcrumb({ commit, rootState }, name) {
    commit(types.SET_LAST_BREADCRUMB, { route: rootState.route, name });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/actions.js